import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { StaticQuery, graphql } from 'gatsby'

import useHeader from '../../hooks/useHeader'

import styles from '../../styles/components/Header/HeaderLogo.module.css'

const HeaderLogo = props => {
  const header = useHeader()
  const logoClassName = classnames(styles.logo, {
    [styles.logoFixed]: header.isFixed
  })

  const sectionId = props.markdownRemark.frontmatter.id
  const onLogoClick = event => {
    event.preventDefault()
    document.getElementById(sectionId).scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    })
  }

  return (
    <a href={`#${sectionId}`} onClick={onLogoClick}>
      <img src='logo.svg' alt='logo' className={logoClassName} />
    </a>
  )
}

const headerLogoQuery = graphql`
  query HeaderLogoQuery {
    markdownRemark(frontmatter: { id: { eq: "intro" } }) {
      frontmatter {
        id
      }
    }
  }
`

HeaderLogo.propTypes = {
  allMarkdownRemark: PropTypes.shape({
    nodes: PropTypes.arrayOf(
      PropTypes.shape({
        frontmatter: PropTypes.shape({
          id: PropTypes.string.isRequired
        })
      })
    )
  })
}

export default props => (
  <StaticQuery query={headerLogoQuery} render={data => <HeaderLogo {...data} {...props} />} />
)
